import React from 'react';
import cx from 'classnames';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import { SortableElement } from 'react-sortable-hoc';

// Components
import { DeleteIcon } from '@zola/zola-ui/src/components/SvgIcons/DeleteIcon';
import { EditIcon } from '@zola/zola-ui/src/components/SvgIcons/EditIcon';
import DragHandle from '../../../../../common/ui/DragHandle';

const EditPageSortableItem = SortableElement(
  ({
    entity,
    onEdit,
    onDelete,
    entityDetail,
    entityType,
  }: {
    entity: GenericEntityType;
    onEdit: (e: GenericEntityType) => void;
    onDelete: (e: GenericEntityType) => void;
    entityDetail: (e: GenericEntityType) => React.ReactNode;
    entityType: string;
  }) => {
    const noPropagate = (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    };

    return (
      <li
        className={`edit-page entity-item edit-page-entity-item entity-item--${entityType}`}
        onClick={() => onEdit(entity)}
      >
        <DragHandle />
        <div className="entity-details">{entityDetail(entity)}</div>
        <div className="entity-actions" onClick={noPropagate}>
          {onEdit && (
            <button
              onClick={() => onEdit(entity)}
              title="Edit Registry"
              className="edit-btn btn-icon with-tooltip no-tooltip-on-mobile"
              data-tooltip="Edit"
              type="button"
            >
              <EditIcon />
            </button>
          )}
          {onDelete && (
            <button
              onClick={() => onDelete(entity)}
              title="Delete Registry"
              className="delete-btn btn-icon with-tooltip no-tooltip-on-mobile"
              data-tooltip="Delete"
              type="button"
            >
              <DeleteIcon />
            </button>
          )}
        </div>
      </li>
    );
  }
);

type AddClassType = {
  addClass?: string;
};

type EntityNameProps = AddClassType & { name?: string };
export const EntityName: React.FC<EntityNameProps> = ({ children, name, addClass }) => {
  const classNames = cx('entity-name', { [`${addClass}`]: addClass });
  return <h4 className={classNames}>{name || children}</h4>;
};

type EntityTypeProps = AddClassType & { type?: string };
export const EntityType: React.FC<EntityTypeProps> = ({ children, type, addClass }) => {
  const classNames = cx('entity-type', { [`${addClass}`]: addClass });
  return <div className={classNames}>{type || children}</div>;
};

type EntityDescriptionProps = AddClassType & { description?: string };
export const EntityDesciption: React.FC<EntityDescriptionProps> = ({
  children,
  description,
  addClass,
}) => {
  const classNames = cx('entity-description', { [`${addClass}`]: addClass });
  return <div className={classNames}>{description || children}</div>;
};

export default EditPageSortableItem;
